function ActionStepMap({ title, onBack, children }) {
  return (
    <article className="panel">
      <div className="panel-header">
        <h2>{title}</h2>
        <button className="button-ghost" type="button" onClick={onBack}>
          Go back
        </button>
      </div>
      {children}
    </article>
  );
}

export default ActionStepMap;
